module.exports = __webpack_public_path__ + "static/img/ice-cream-2.faa6f5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ice-cream-2.png
// module id = ze3C
// module chunks = 0